<app-details-historie-card
  testId="tp-historie"
  [subtitle]="'testPlans.form.history.subtitle' | translate"
  [tabs]="reiter()"
  [(activeTab)]="aktiverReiter"
>
  <ng-template appDetailsHistoriePanel="uebergabe">
    <app-uebergabe-panel
      testIdPrefix="tp"
      [chain]="stufen()"
      [closed]="kette()?.closed ?? false"
      [closedAt]="kette()?.closedAt ?? null"
      [activeSince]="seit()"
      [vorlagen]="vorlagen()"
      [personOptions]="personOptions()"
      [readonly]="readonly()"
      [disabledReason]="sperrGrund()"
      [handOffDisabledReason]="uebergebenSperrGrund()"
      [platzhalter]="'testPlans.form.history.platzhalter' | translate"
      [busy]="beschaeftigt()"
      [errorMessage]="aktionsFehler()"
      [status]="ketteStatus()"
      [entwurf]="entwurf()"
      (entwurfChange)="entwurfGeaendert($event)"
      (handOff)="uebergeben($event)"
      (close)="abschliessen()"
      (reopen)="wiederOeffnen()"
      (skip)="ueberspringen($event)"
      (retry)="ladeKette()"
    />
  </ng-template>
  <ng-template appDetailsHistoriePanel="verlauf">
    <app-verlauf-liste [eintraege]="verlaufEintraege()" [status]="verlaufStatus()" (retry)="ladeVerlauf()" />
    @if (verlaufGekuerzt() && verlaufStatus() === 'bereit') {
      <p class="tp-historie__gekuerzt" data-testid="tp-verlauf-gekuerzt">
        {{ 'testPlans.form.history.gekuerzt' | translate }}
      </p>
    }
  </ng-template>
  <ng-template appDetailsHistoriePanel="notizen">
    <textarea
      class="tp-historie__notiz"
      rows="3"
      data-testid="tp-notes"
      [formControl]="notesControl()"
      [readOnly]="readonly()"
      [attr.aria-label]="'testPlans.form.history.notesLabel' | translate"
      [attr.maxlength]="maxNotes"
      [placeholder]="'testPlans.form.history.notesPlaceholder' | translate"
    ></textarea>
  </ng-template>
</app-details-historie-card>
